import { TemplateResult, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import globalStyles from './styles/outline-ratings-layout-bjc-west.global.pcss?inline';

declare global {
  interface Window {
    initPressGaneyWidgets?: () => void;
  }
}

/**
 * The OutlineRatingsLayoutBjcWest component
 * @element outline-ratings-layout-bjc-west
 */
@customElement('outline-ratings-layout-bjc-west')
export class OutlineRatingsLayoutBjcWest extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });

  @property({ type: String, reflect: true, attribute: 'variant' })
  variant: 'hero' | 'card' | 'default' = 'default';

  firstUpdated(): void {
    // Hide reviews section if empty.
    setTimeout(() => {
      const ratingsWrapper = this.querySelector('.bsr-rating-wrapper');
      if (!ratingsWrapper) {
        this.style.display = 'block';
      }
    }, 800);

    if (typeof window.initPressGaneyWidgets === 'function') {
      window.initPressGaneyWidgets();
    }
  }

  render(): TemplateResult {
    return html`
      <div class="outline-ratings-layout-bjc-west">
        <div class="heading">
          <slot name="heading"></slot>
        </div>
        <slot></slot>

        <slot name="disclaimer-text"></slot>
      </div>
    `;
  }
}

// Declare the custom element for TypeScript
declare global {
  interface HTMLElementTagNameMap {
    'outline-ratings-layout-bjc-west': OutlineRatingsLayoutBjcWest;
  }
}
